//@flow
/**
 * Client Actions
 * @module client/actions
 */
import ReactGA from 'react-ga'
import localforage from 'localforage'
import {
  FETCH_CLIENT_REQUEST,
  FETCH_CLIENT_PENDING,
  FETCH_CLIENT_SUCCESS,
  FETCH_CLIENT_FAILURE,
} from './reducer'
import { getClientDetails } from '../../utils/api/client';


const clientStore = localforage.createInstance({
  name: 'client',
})

// refetch the question from server just incase there is an update
/**
 * fetches client details
 * @memberof client/actions
 */
export const fetchClient = () => async (dispatch: Function) => {
  dispatch({
    type: FETCH_CLIENT_REQUEST,
  })
  // get the client from offline cache
  dispatch({
    type: FETCH_CLIENT_PENDING,
    payload: await clientStore.getItem('details'),
  })

  try {
    const clientDetails = await getClientDetails()
    clientStore.setItem('details', clientDetails.data.data)
    dispatch({
      type: FETCH_CLIENT_SUCCESS,
      payload: clientDetails.data.data,
    })
    ReactGA.event({
      category: 'Client',
      action: 'Accessed Client',
    })
  } catch (err) {
    return dispatch({
        type: FETCH_CLIENT_FAILURE,
        payload: err,
        error: true,
      })
  }
}



// WEBPACK FOOTER //
// ./src/state/client/actions.js